import moment from 'moment';
import A8Utils from '..';

const formatDate = (dateString) => {
    return moment(dateString).format(A8Utils.constant.dateTimeFormat);
}

export default formatDate